import { showSimpleDialog } from '../../ui_popup/showSimpleDialog.ts';
import { ReadyUpExceedLimitWarningContent } from './UIRoomWarningPopupReadyUpExceedLimit.ts';
import { StartGameExceedLimitWarningContent } from './UIRoomWarningPopupStartGameExceedVPLimit.ts';
export var WarningType = /*#__PURE__*/ function(WarningType) {
    WarningType[WarningType["StartGameVPExceededRecommendedLimit"] = 0] = "StartGameVPExceededRecommendedLimit";
    WarningType[WarningType["ReadyUpVPExceededRecommendedLimit"] = 1] = "ReadyUpVPExceededRecommendedLimit";
    return WarningType;
}({});
export class UIRoomWarningController {
    static runWithWarning(continuationAction, warningType, roomState) {
        const warningPopup = this.getWarningPopupContent(warningType, roomState);
        if (!warningPopup.shouldShowWarning()) {
            continuationAction();
            return;
        }
        showSimpleDialog({
            title: warningPopup.getTitle(),
            body: warningPopup.getDescription(),
            onConfirm: ()=>continuationAction(true),
            showCancelBtn: true
        });
    }
    static getWarningPopupContent(warningType, roomState) {
        switch(warningType){
            case 0:
                return new StartGameExceedLimitWarningContent(roomState);
            case 1:
                return new ReadyUpExceedLimitWarningContent(roomState);
        }
    }
}
